import axios from 'axios'
import constants from '../constants'

const DESIGN_PATH = `${constants.urlPrefix}/api/designs`;
const ILLUSTRATION_PATH = `${DESIGN_PATH}/illustrations`;
const TEMPLATES_PATH = `${constants.urlPrefix}/api/templates`;
const TEMPLATES_PATH_RENDERER = `${constants.RENDERER_DOMAIN}/templates`;
const TEMPLATES_GROUPED_PATH = `${constants.urlPrefix}/api/templates/grouped`;
const REVISION_PATH = `${constants.urlPrefix}/api/revisions`;
const DESIGNER_PATH = `${constants.urlPrefix}/api/designers`;
const ACCENTS_PATH = `${DESIGN_PATH}/accents`;
const IMPORT_CLASSIC_PATH = `${constants.urlPrefix}/api/import/classic`;
const CLASSIC_COUNT_PATH = `${DESIGN_PATH}/classic/count`;

const getDesignsByTemplatePreview = (templateId) => axios.get(`${DESIGN_PATH}/preview`, { params: { templateId } });

const getDesignsByCustomSizePreview = (customSize) => axios.get(`${DESIGN_PATH}/custom/preview`, { params: { customSize } });

const getPublicDesigns = () => axios.get(DESIGN_PATH);

const getMemberDesigns = (memberId) => axios.get(DESIGN_PATH, { params: { memberId } });

const getDesignRevisions = (designId) => axios.get(REVISION_PATH, { params: { designId } });

const getRemovedTemplates = () => axios.get(`${TEMPLATES_PATH}/removed`);

const getTemplatesByStatusAndSize = (status, size, page = 0, pageSize = 30, search = '', orderBy = null, orderByDirection = 'desc') =>
    axios.get(TEMPLATES_PATH, { params: { status, size, page, pageSize, search, orderBy, orderByDirection } });

function getTemplatesByStatusAndSizeGrouped(size, page = 0, pageSize = 30, search = '', sizes = '', colors = '', category = '') {
    return axios.get(TEMPLATES_GROUPED_PATH, {params: {size, page, pageSize, search, sizes, colors, category}});
}

function getTemplatesGroupedByFamily(page = 0, pageSize = 3, search = '') {
    return axios.get(TEMPLATES_GROUPED_PATH + '/family', {params: {page, pageSize, search}});
}

function getTemplateSets(templateId) {
    return axios.get(`${constants.urlPrefix}/api/templates/${templateId}/sets`);
}

const getTemplates = (filters) => axios.get(TEMPLATES_PATH, { params: filters })

const getFavoriteTemplates = () => axios.get(`${TEMPLATES_PATH}/favorites`);

const getFavoriteIllustrations = () => axios.get(`${ILLUSTRATION_PATH}/favorites`);

const getTemplatesCountBySize = () => axios.get(`${TEMPLATES_PATH}/count/size`)

const getDesign = (id, complete = false, tag = false, timestamp = new Date().getTime()) => axios.get(DESIGN_PATH, {
    params: {
        id, complete, tag, timestamp
    }
});

const createDesignFromParent = (dto) => axios.post(DESIGN_PATH, dto);

const createDesignFromClassic = (dto) => axios.post(IMPORT_CLASSIC_PATH, dto);

const removeDesign = (id) => axios.delete(`${DESIGN_PATH}/${id}`);

const restoreDesign = (id) => axios.put(`${DESIGN_PATH}/${id}/restore`);

const finalRemoveDesign = (id) => axios.delete(`${DESIGN_PATH}/${id}/final`);

const generateTemplateLinkInvite = (id, creatorName) => axios.post(`${DESIGN_PATH}/${id}/template-link/invite`, creatorName);

let updateDesignPromiseChain = Promise.resolve();
const updateDesign = (dto) => {
    updateDesignPromiseChain = updateDesignPromiseChain.then(() => axios.put(DESIGN_PATH, dto));
    return updateDesignPromiseChain;
}

let updateDesignHtmlPromiseChain = Promise.resolve();
const updateDesignHtml = (dto) => {
    updateDesignHtmlPromiseChain = updateDesignHtmlPromiseChain.then(() => axios.put(`${DESIGN_PATH}/html`, dto));
    return updateDesignHtmlPromiseChain;
}
const refreshQRThumbnail = (id) => axios.post(`${DESIGN_PATH}/${id}/thumbnail/refresh`);
const registerDownload = (id) => axios.put(`${DESIGN_PATH}/${id}/registerDownload`);

const updateDesignColors = (dto) => axios.put(`${DESIGN_PATH}/colors`, dto);

const updateDesignFonts = (id, fonts) => axios.put(`${DESIGN_PATH}/fonts`, { id, fonts });

const getIllustration = (id) => axios.get(`${constants.urlPrefix}/api/illustration/${id}`);

const getDesignIllustrations = (designId, page = 0, search, folder) => axios.get(`${ILLUSTRATION_PATH}/design/${designId}`, { params: { page, search, folder } });

const removeIllustration = (illustrationId) => axios.delete(`${ILLUSTRATION_PATH}/${illustrationId}`);

const updateIllustrationPrivacy = (illustrationId, privacy) => axios.put(`${ILLUSTRATION_PATH}/${illustrationId}/privacy/${privacy}`);

const uploadIllustration = (formData) => axios.post(`${ILLUSTRATION_PATH}/upload`, formData);

const uploadImageIllustration = (templateId, formData) => axios.post(`${ILLUSTRATION_PATH}/${templateId}/upload/image`, formData);

const confirmUploadIllustration = (colors, templateId, popular) => axios.post(`${ILLUSTRATION_PATH}/upload/confirm`, { colors, templateId, popular });

const linkIllustration = (illustrationId, templateId) => axios.post(`${ILLUSTRATION_PATH}/link`, { illustrationId, templateId });

const unlinkIllustration = (illustrationId, templateId) => axios.delete(`${ILLUSTRATION_PATH}/link/${illustrationId}/${templateId}`);

const getFreeImage = (assetId) => axios.get(`${constants.urlPrefix}/api/freeImage/${assetId}`);

const markAsTemplate = (templateId) => axios.put(`${DESIGN_PATH}/${templateId}/template`);

const markAsModified = (designId, lastSavedTag) => axios.put(`${DESIGN_PATH}/${designId}/modified`, { lastSavedTag });

const refreshThumbnail = (designId) => axios.get(`${TEMPLATES_PATH_RENDERER}/${designId}/refreshThumb`);

const refreshThumbnails = () => axios.get(`${TEMPLATES_PATH}/refreshThumbs`);

const getDesigners = () => axios.get(DESIGNER_PATH);

const selfAssign = (designId) => axios.put(`${DESIGN_PATH}/${designId}/assign`);

const makeCopy = (designId, name, size, width, height, unit) =>
    axios.post(`${DESIGN_PATH}/${designId}/copy`, { name, size, width, height, unit });

const getDesignAlternativeName = (id, name) => axios.get(`${DESIGN_PATH}/name`, { params: { id, name } });

const getDesignsForLocation = (locationId) => axios.get(DESIGN_PATH, { params: { locationId, mo: false, page: 1, batch: 1000 } });

const getMenuObjectDesignsForLocation = (locationId, page, batch, loadClassic) => axios.get(DESIGN_PATH, { params: { locationId, mo: true, page, batch, loadClassic: loadClassic } });

const checkLastSaveTag = (designId, lastSavedTag) => axios.get(`${DESIGN_PATH}/${designId}/checktag/${lastSavedTag}`);

const getDesignWebsiteToken = (id) => axios.get(`${DESIGN_PATH}/websiteToken`, { params: { id } });

const getDesignAccents = (designId) => axios.get(`${ACCENTS_PATH}/${designId}`);

const getClassicMenuCountForLocation = (locationId) => axios.get(CLASSIC_COUNT_PATH, { params: { locationId } });

function quickUpdateDesignTemplate (designId, templateId, locationId) {
    return axios.post(`${DESIGN_PATH}/${designId}/template`, {
        templateId,
        locationId
    });
}

function quickCreateDesignBySize (size, locationId) {
    return axios.post(`${DESIGN_PATH}/size`, {
        size,
        locationId
    });
}

function designPing(designId, inUse, inUseMemberId) {
    return axios.post(`${DESIGN_PATH}/${designId}/ping`, {
        inUse,
        inUseMemberId
    });
}

function designPingPos(designId) {
    return axios.post(`${DESIGN_PATH}/${designId}/ping/pos`);
}

function designPingPosPending(designId) {
    return axios.post(`${DESIGN_PATH}/${designId}/ping/posPending`);
}

function designExecutePendingSync(designId) {
    return axios.post(`${DESIGN_PATH}/${designId}/executePosPending`);
}

function syncPOS(designId) {
    return axios.post(`${DESIGN_PATH}/${designId}/pos/sync`);
}

function togglePOSAutoSync(designId) {
    return axios.post(`${DESIGN_PATH}/${designId}/pos/sync/toggle`);
}

function toggleDSAAutoSync(designId, forcedValue) {
    return axios.post(`${DESIGN_PATH}/${designId}/dsa/sync/toggle`, null, { params: { forcedValue } });
}

function toggleLinksAutoSync(designId, forcedValue) {
    return axios.post(`${DESIGN_PATH}/${designId}/links/sync/toggle`, null, { params: { forcedValue } });
}

export default {
    syncPOS,
    togglePOSAutoSync,
    toggleDSAAutoSync,
    toggleLinksAutoSync,

    getPublicDesigns,
    getMemberDesigns,

    getDesignRevisions,
    getDesignsByTemplatePreview,
    getDesignsByCustomSizePreview,
    getDesignsForLocation,
    getMenuObjectDesignsForLocation,
    getRemovedTemplates,
    getTemplatesByStatusAndSize,
    getTemplatesByStatusAndSizeGrouped,
    getTemplatesGroupedByFamily,
    getTemplateSets,
    getTemplates,
    getTemplatesCountBySize,
    getDesign,
    createDesignFromParent,
    createDesignFromClassic,
    updateDesign,
    updateDesignColors,
    updateDesignFonts,
    updateDesignHtml,
    refreshQRThumbnail,
    registerDownload,

    getIllustration,
    getDesignIllustrations,
    uploadImageIllustration,
    uploadIllustration,
    confirmUploadIllustration,
    removeIllustration,
    updateIllustrationPrivacy,

    getFreeImage,

    removeDesign,
    restoreDesign,
    finalRemoveDesign,
    linkIllustration,
    unlinkIllustration,
    markAsTemplate,
    markAsModified,

    refreshThumbnail,
    refreshThumbnails,

    getDesigners,

    selfAssign,
    makeCopy,

    getDesignAlternativeName,
    checkLastSaveTag,

    getDesignWebsiteToken,

    getDesignAccents,
    getClassicMenuCountForLocation,

    quickUpdateDesignTemplate,
    quickCreateDesignBySize,

    designPing,
    designPingPos,
    designPingPosPending,
    designExecutePendingSync,
    
    generateTemplateLinkInvite,

    getFavoriteTemplates,
    getFavoriteIllustrations,
}
